<template>
  <div class="home">
    <div class="row justify-content-center">
      <div class="col-xl-6 col-md-8 col-12">
        <!--<b-carousel
          id="carousel-1"
          :interval="2000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
        >
          <b-carousel-slide img-src="./img/basket.jpg"></b-carousel-slide>
          <b-carousel-slide img-src="./img/football.jpg"></b-carousel-slide>
          <b-carousel-slide img-src="./img/tennis.jpg"></b-carousel-slide>
          <b-carousel-slide img-src="./img/multisports.jpg"></b-carousel-slide>
        </b-carousel>
        -->
        <b-img src="./img/slogan.jpg" fluid></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr style="background: white;"></div>
    </div>
    <div class="row justify-content-center">
      <div class="col text-center" style="margin-top:10px;" v-if="prognostics.length > 0">
        <h4 class="text-warning">Nos derniers pronostics</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-12" style="margin-top:10px;" v-if="!auth.user || !auth.user.subscribed">
        <Prognostic v-bind:prognostic="{ date: moment().unix(), title: 'Devenir VIP', 'type': 'vip', name: 'Devenir VIP', text: 'Devenez VIP et accédez en exclusivité aux pronostics du jour' }" />
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12 text-center" v-if="prognostics.length == 0">
        <b-spinner type="grow" variant="warning" style="width: 5rem; height: 5rem;" ></b-spinner>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12" style="margin-top:10px;" v-for="prognostic in prognostics" v-bind:key="prognostic.id">
        <Prognostic v-bind:prognostic="prognostic"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Prognostic from '@/components/Prognostic.vue'
import { auth, db } from '@/firebase.js'

export default {
  data: () => ({ prognostics: null, auth: auth }),
  components: {
    Prognostic
  },/*
  firestore: {
    prognostics: db.collection('prognostics').where('date', '<', moment().startOf('day').unix()).orderBy('date', 'desc')
  },*/
  methods: {
    moment(ts) { return ts ? moment.unix(ts) : moment() }
  },
  watch: {
    auth: {
      immediate: true,
      handler(auth) {
        if(auth.user && auth.user.subscribed)
          this.$bind('prognostics', db.collection('prognostics').where('date', '>=', moment().startOf('day').subtract(7, 'day').unix()).orderBy('date', 'desc'))
        else
          this.$bind('prognostics', db.collection('prognostics').where('date', '>=', moment().startOf('day').subtract(7, 'day').unix()).where('date', '<', moment().startOf('day').unix()).orderBy('date', 'desc'))
      },
    },
  }
}
</script>